import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Dropdown } from 'components/v2/Dropdown'
import IconButton from 'components/v2/IconButton'
import { DotsIcon } from 'components/Icons'
import List from 'components/v2/List'
import { StyledLink } from 'components/v2/Link'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { getStateNameByCountryAndStateCode } from 'utils/states'
import { COUNTRY_CODES } from 'utils/countries'
import { useLogin } from 'features/Login/hooks'
import { GTTPlace } from 'gql/types.generated'
import { businessClientsToString } from 'features/Trips/utils'
import { isEmpty } from 'lodash'

export const PlacesList = ({ places }: { places: GTTPlace[] }): ReactElement => {
  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.PLACE, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.code" defaultMessage="Code" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.city" defaultMessage="City" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.state" defaultMessage="State" />
            </Th>
            <Th>
              <FormattedMessage id="places.list.clientSite" defaultMessage="Client - Site" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.tags" defaultMessage="Tags" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {places.map((place): ReactElement => {
            const countryCode = place.countryCode !== null ? place.countryCode : COUNTRY_CODES.MEXICO
            return (
              <Tr key={place.id}>
                {canWrite(FEATURES.PLACE, login.accessToken.policies) && (
                  <Td>
                    <Dropdown
                      toggle={<IconButton icon={<DotsIcon />} noBorder smallPadding />}
                      noPadding
                      noIndicator
                      left
                    >
                      <List.Container>
                        <List.Item noPadding>
                          <List.Link to={`/places/${place.id}`}>
                            <FormattedMessage id="places.list.actions.edit" defaultMessage="Edit place" />
                          </List.Link>
                        </List.Item>
                      </List.Container>
                    </Dropdown>
                  </Td>
                )}
                <Td>{place.name}</Td>
                <Td>{place.code}</Td>
                <Td>{place.parent.name}</Td>
                <Td>{getStateNameByCountryAndStateCode(countryCode || '', place.stateCode || '')}</Td>
                <Td>
                  {!isEmpty(place.businessClient)
                    ? businessClientsToString([
                        {
                          name: place.businessClient?.name || '',
                          businessSites: place.businessSite ? [place.businessSite] : []
                        }
                      ])
                    : '-'}
                </Td>
                <Td>
                  {place.tags.length > 0 ? (
                    <Dropdown toggle={<StyledLink>{place.tags.length}</StyledLink>} noPadding>
                      <List.Container>
                        {place.tags.map((tag: TSFixMe, index: TSFixMe): TSFixMe => {
                          return <List.Item key={index}>{tag}</List.Item>
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : (
                    0
                  )}
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
